export default __webpack_public_path__ + "static/media/the_pope_video_pt.86a01554.svg";